"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const LinkedinBox = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#0A66C2",
        fillRule: "evenodd",
        d: "M20.551 2H3.508C2.692 2 2 2.645 2 3.439V20.56c0 .795.454 1.44 1.27 1.44h17.043C21.13 22 22 21.355 22 20.56V3.44C22 2.645 21.368 2 20.551 2ZM9.62 9.619h2.692v1.372h.03c.41-.74 1.623-1.491 3.122-1.491 2.877 0 3.68 1.528 3.68 4.357v5.286h-2.857v-4.765c0-1.267-.506-2.378-1.689-2.378-1.436 0-2.12.972-2.12 2.569v4.574h-2.86V9.619Zm-4.762 9.524h2.857V9.619H4.857v9.524ZM8.071 6.286a1.785 1.785 0 1 1-3.57 0 1.785 1.785 0 0 1 3.57 0Z"
      }
    )
  );
};
export default LinkedinBox;
